exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.delete[data-v-1a3670b1] {\n  position: absolute;\n  left: 220px;\n}\n.delete[data-v-1a3670b1]:hover {\n  color: red;\n  cursor:pointer\n}\n.img-box[data-v-1a3670b1]{\n  overflow: hidden;\n}\n.img-box img[data-v-1a3670b1]{\n  width: 30px;\n  float: left;\n  margin-right: 5px;\n}\n", ""]);

// exports
